
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.1875 4.125C4.6007 4.125 4.125 4.6007 4.125 5.1875V15.8125C4.125 16.3993 4.6007 16.875 5.1875 16.875H15.8125C16.3993 16.875 16.875 16.3993 16.875 15.8125V10.5H19V15.8125C19 17.5729 17.5729 19 15.8125 19H5.1875C3.42709 19 2 17.5729 2 15.8125V5.1875C2 3.42709 3.42709 2 5.1875 2H10.5V4.125H5.1875Z"}}),_c('path',{attrs:{"d":"M16.875 4.125H12.625V2H17.9375C18.5243 2 19 2.4757 19 3.0625V8.375H16.875V4.125Z"}}),_c('path',{attrs:{"d":"M9.74872 9.74872L17.1862 2.31122L18.6888 3.81382L11.2513 11.2513L9.74872 9.74872Z"}})])
          )
        }
      }
    